module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Reports_16"],"path":[{"$":{"d":"M6,7h6V8H6Zm9-3V14H13v2H1V2H3V0h7ZM12,14H3V3H2V15H12Zm1-9L9.3,2H5V12h8ZM6,6h4V5H6Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Reports_16.svg
// module id = 3H+w
// module chunks = 1